'use strict';

function getArrayWithOffset(arr, n, alternate, offset) {
  var val;
  if (alternate > 1) {
    val = arr[n + (alternate - 1) * offset];
  }
  return val || arr[n];
}

module.exports = getArrayWithOffset;


// WEBPACK FOOTER //
// ./~/sugar-date/date/internal/getArrayWithOffset.js